import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ChevL  = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
const ChevR  = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
const ChevsL = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
const ChevsR = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>

const PgBtn = ({ children, active, disabled, onClick, title }) => (
    <button
        title={title}
        disabled={disabled}
        onClick={onClick}
        className={`sb-pgbtn${active ? ' sb-pgbtn-active' : ''}`}
    >
        {children}
    </button>
)

const Pages = ({ paginationData: { totalPages }, changePage, pageNumber }) => {
    const { t } = useTranslation();

    const [itemNumbers, setItemNumbers] = useState([])

    useEffect(() => {
        let array = []
        for (
            let n = pageNumber > 1 ? pageNumber - 1 : 1;
            n <= (pageNumber < totalPages ? pageNumber + 1 : totalPages);
            n++
        ) { array.push(n) }
        setItemNumbers(array)
    }, [pageNumber, totalPages, changePage])

    const go = (page) => { if (pageNumber !== page) changePage(page) }

    return (
        <div className="sb-pagination">
            <PgBtn title={t('pagination.firstPage', 'First page')}    disabled={pageNumber <= 1}            onClick={() => go(1)}             ><ChevsL /></PgBtn>
            <PgBtn title={t('pagination.previousPage', 'Previous page')} disabled={pageNumber <= 1}            onClick={() => go(pageNumber - 1)}><ChevL  /></PgBtn>

            {totalPages > 3 && pageNumber > 2 && (
                <span style={{ width:'34px', textAlign:'center', color:'var(--sb-muted)', fontSize:'14px', letterSpacing:'1px', userSelect:'none' }}>…</span>
            )}

            {itemNumbers.map((n) => (
                <PgBtn key={n} active={n === pageNumber} onClick={() => go(n)}>{n}</PgBtn>
            ))}

            {totalPages > 3 && pageNumber < totalPages - 1 && (
                <span style={{ width:'34px', textAlign:'center', color:'var(--sb-muted)', fontSize:'14px', letterSpacing:'1px', userSelect:'none' }}>…</span>
            )}

            <PgBtn title={t('pagination.nextPage', 'Next page')} disabled={pageNumber >= totalPages} onClick={() => go(pageNumber + 1)}><ChevR  /></PgBtn>
            <PgBtn title={t('pagination.lastPage', 'Last page')} disabled={pageNumber >= totalPages} onClick={() => go(totalPages)}    ><ChevsR /></PgBtn>
        </div>
    )
}

export default Pages
